import React, { Component } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import type { FlagService } from '@atlassian/jira-flags';
import errorFlag from '../../flags/set-pages-link-error/index.tsx';
import type { AppProps } from '../model/index.tsx';
import Content from './modal/content/index.tsx';
import Modal from './modal/index.tsx';

export type Props = AppProps & {
	flagService: FlagService;
};

// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
class ManagePagesLinkModal extends Component<Props, Record<any, any>> {
	onPagesLinkEnabledChange = () => {
		const {
			config: { isPagesLinkEnabled, setPagesLink },
			flagService,
		} = this.props;
		setPagesLink(!isPagesLinkEnabled).catch(() => {
			flagService.showFlag(errorFlag());
		});
	};

	renderContent = () => (
		<Content
			isEnabled={this.props.config.isPagesLinkEnabled}
			onEnabledChange={this.onPagesLinkEnabledChange}
		/>
	);

	render() {
		const isOpen = this.props.isOpen ?? false;

		return (
			<ModalTransition>
				{isOpen && <Modal Content={this.renderContent} onClose={this.props.onClose} />}
			</ModalTransition>
		);
	}
}

export default ManagePagesLinkModal;
